export default __webpack_public_path__ + "static/media/37.169158e5.jpeg";